import type { FaireProductEntity } from "../../entity_types/product";

export const p_dyapjkvcv5: FaireProductEntity = {
  token: "p_dyapjkvcv5",
  type: "product",
  name: "Irish Sea Moss",
  brandToken: "b_9lnqwiw9kl",
  brandName: "Cymbiotika",
  imageUrl:
    "https://cdn.faire.com/fastly/ab6974cdca9e93e101659a95aac7c9ec88154ddf27a887bbbd1344e0dd0c7883.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19143e94b3668f995dbfed0ad76dc969744e0508e2893dd0253d09821506301f.jpeg",
    "https://cdn.faire.com/fastly/732ecac79f7121ca2d465e7d6c69e1069e75861abe2a9d4f601cfa369c71d299.webp",
  ],
  priceDollars: 54.04,
  description:
    "Cymbiotika’s Irish Sea Moss is a next-generation wellness formula crafted to elevate your everyday health. This nutrient-dense blend combines Organic Irish Sea Moss with fulvic minerals, prebiotics, and postbiotics to support a thriving gut, radiant skin, and hormonal balance. Enhanced with soothing aloe and advanced nutrient absorption technology, our formula takes a holistic approach to well-being, helping you feel vibrant, energized, and truly nourished from within.",
  tags: [],
  msrpDollars: 90.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:32.950Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
